// Simplified theme utilities to match the mobile app's logic

/**
 * Applies a theme (dark/light) and/or a primary accent color.
 * Effectively mirrors the mobile app's data storage.
 */
export const applyThemeSettings = (themeMode, accentColor) => {
  if (themeMode) {
    document.documentElement.setAttribute('data-theme', themeMode);
    localStorage.setItem('theme', JSON.stringify(themeMode));
  }

  if (accentColor) {
    document.documentElement.style.setProperty('--primary-accent', accentColor);
    localStorage.setItem('primaryColor', JSON.stringify(accentColor));
  }
};

/**
 * Loads and applies saved theme settings on app startup.
 */
export const loadThemeSettings = () => {
  try {
    const savedTheme = JSON.parse(localStorage.getItem('theme')) || 'light';
    const savedAccent = JSON.parse(localStorage.getItem('primaryColor'));

    document.documentElement.setAttribute('data-theme', savedTheme);
    
    if (savedAccent) {
      document.documentElement.style.setProperty('--primary-accent', savedAccent);
    }
    
    return { themeMode: savedTheme, accentColor: savedAccent };
  } catch (error) {
    return { themeMode: 'light', accentColor: null };
  }
};

/**
 * Resets to default settings.
 */
export const clearThemeSettings = () => {
  localStorage.removeItem('theme');
  localStorage.removeItem('primaryColor');
  document.documentElement.setAttribute('data-theme', 'light');
  document.documentElement.style.removeProperty('--primary-accent');
};

// Legacy compatibility exports (empty or non-functional to avoid crashes while transitioning)
export const applyCustomTheme = (color) => applyThemeSettings(null, color);
export const loadCustomTheme = () => loadThemeSettings().accentColor ? { primaryColor: loadThemeSettings().accentColor } : null;
export const clearCustomTheme = () => clearThemeSettings();
export const shouldUseDarkMode = () =>
  document.documentElement.getAttribute('data-theme') === 'dark';
export const hexToHsl = () => [0, 0, 0];